'use client';

import Script from 'next/script';

const CA_PUB_ID = '3135721177140607';
const MediaAdComponent = ({ inactive = true }: { inactive: boolean }) => {
  if (inactive) return null;
  return (
    <>
      {/* Google Ads Script */}
      <Script
        async
        src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-${CA_PUB_ID}`}
        crossOrigin="anonymous"
        strategy="afterInteractive"
      />
      {/* Ad Container */}
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={`ca-pub-${CA_PUB_ID}`}
        data-ad-slot="2080619491"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
      <Script id="adsbygoogle-init-media" strategy="afterInteractive">
        {`
          (adsbygoogle = window.adsbygoogle || []).push({});
        `}
      </Script>
    </>
  );
};

export default MediaAdComponent;
